import { connect } from "react-redux";

import _ from "lodash";
import DealDetailsView from "./view.jsx";
import { fetchDealHistory, fetchDealInsightsSignals, invalidateDealInsightsSignals,  fetchDeal, invalidateDeal } from "src/legacy/redux/actions/dealInsights";
import withUseHooks from "src/legacy/components/withUseHooks";

const mapStateToProps = (state, ownProps) => {

  return {
    primaryColor: _.get(state.account, 'theme.primaryColor', '#E50C58'),
    deal: _.get(state,"legacyRootReducer.dealInsights.currentDeal.item",{}),
    history: _.get(state, "legacyRootReducer.dealInsights.history.items", []),
    signals: _.get(state, `legacyRootReducer.dealInsights.signals`, {}),
    isHistoryFetching: _.get(state, "legacyRootReducer.dealInsights.history.fetching",false)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchDealHistory: (id, params) => {
      return dispatch(fetchDealHistory(id, params));
    },
    fetchDealInsightsSignals: (id, page) => {
      return dispatch(fetchDealInsightsSignals(id, page));
    },
    invalidateDealInsightsSignals: () => {
      return dispatch(invalidateDealInsightsSignals());
    },
    fetchDeal: (id) => {
      return dispatch(fetchDeal(id))
    },
    invalidateDeal: () => {
      return dispatch(invalidateDeal())
    }
  };
};

const DealDetailsPage = connect(
  mapStateToProps,
  mapDispatchToProps
)(DealDetailsView);

export default withUseHooks(DealDetailsPage);
